import { URLS } from "@core/shared/utils";
import { BaseLink } from "@design-system/components/link";
import { settingsAtom } from "@framework/shared/atoms";

export function HeaderLogo() {
  const general = settingsAtom.use("general");

  // Handle case when settings are not loaded or empty
  if (!general) {
    return (
      <BaseLink
        to={URLS.home}
        title="Mentor Me"
        className="flex items-center space-x-2 text-2xl font-bold"
      >
        Mentor Me
      </BaseLink>
    );
  }

  if (!general?.logo) {
    return (
      <BaseLink
        to={URLS.home}
        title={general.appName || "Mentor Me"}
        className="flex items-center space-x-2 font-bold md:text-2xl"
      >
        {general.appName || "Mentor Me"}
      </BaseLink>
    );
  }

  return (
    <>
      <BaseLink
        to={URLS.home}
        title={general.appName}
        className="flex items-center rounded-xl p-1 transition hover:bg-slate-100/80 dark:hover:bg-slate-800/80"
      >
        <img
          src={general.logo.url}
          alt={general.appName}
          className="max-h-12 max-w-[9rem] object-contain sm:max-w-[11rem]"
        />
      </BaseLink>
    </>
  );
}
